import api from '@api/Api';

export default {

    getIntegrations() {
        return api().get(`/integrations`);
    },

    getIntegration(slug) {
        return api().get(`/integrations/${slug}`);
    },

}
